import { useFeatureFlags } from 'hooks/useFeatureFlags'

import { InputSelectControl } from '@sequencehq/core-components'

import {
  RevenueClassification,
  RevenueRecognitionMethod
} from 'common/types/revenueRecognition.types'
import { filterRevenueRecognitionOptions } from 'common/utils/revenueRecognitionMethod'
import { FieldLabel } from '../layout/FieldLabel'
import { ServicePeriodField } from './ServicePeriodField'
import { DEFAULT_REVENUE_CLASSIFICATION } from '../../constants'

type Props = {
  revenueRecognitionMethod: RevenueRecognitionMethod | undefined
  setRevenueRecognitionMethod: (method: RevenueRecognitionMethod) => void
  revenueClassification: RevenueClassification | undefined
  servicePeriod: ServicePeriodField
}

export const RecognitionMethodField = ({
  revenueRecognitionMethod,
  setRevenueRecognitionMethod,
  revenueClassification,
  servicePeriod
}: Props) => {
  const flags = useFeatureFlags()

  if (!flags.useRevRec) return null

  const options = filterRevenueRecognitionOptions(
    revenueClassification ?? DEFAULT_REVENUE_CLASSIFICATION,
    servicePeriod
      ? { startDate: servicePeriod.start, endDate: servicePeriod.endInclusive }
      : undefined
  )

  return (
    <FieldLabel label="Recognition method">
      <InputSelectControl
        options={options}
        placeholder="Select recognition method"
        initialValue={revenueRecognitionMethod}
        onChange={newValue =>
          setRevenueRecognitionMethod(newValue as RevenueRecognitionMethod)
        }
      />
    </FieldLabel>
  )
}
